
import React from 'react';
import { Row, Col, Tabs, Grid, Card } from 'antd';

function Recommendations() {
    const items = [
        {
            key: '1',
            label: 'Soil Health & Fertility',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>Maintaining soil health is essential for long-term productivity and sustainability. This category focuses on enhancing soil structure, nutrient retention, and microbial activity.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Organic Matter Management" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Regularly add compost, green manure, and cover crops to improve soil organic carbon.</li>
                                    <li>Use mulching with organic materials (straw, wood chips) to maintain soil moisture and suppress weeds.</li>
                                    <li>Avoid excessive tillage to prevent organic matter loss and soil compaction.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Soil Biodiversity Enhancement" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Rotate crops and use cover crops to diversify soil microbial communities.</li>
                                    <li>Avoid monoculture practices to reduce disease pressure and improve soil health.</li>
                                    <li>Encourage mycorrhizal fungi by minimizing soil disturbance and avoiding synthetic inputs.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Sustainable Fertilization" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Apply organic-certified fertilizers, including composted manure and plant-based fertilizers.</li>
                                    <li>Use nitrogen-fixing cover crops like clover, vetch, and alfalfa to enhance soil nitrogen naturally.</li>
                                    <li>Avoid synthetic fertilizers to maintain soil biological integrity and prevent contamination.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Soil pH & Nutrient Balance" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Conduct regular soil tests to monitor pH and nutrient levels.</li>
                                    <li>Adjust pH organically: use elemental sulfur to lower pH or lime to raise it.</li>
                                    <li>Apply organic amendments (e.g., rock phosphate for phosphorus, seaweed extracts for trace minerals).</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </>         
            ),
        },
        {
            key: '2',
            label: 'Water & Soil Conservation',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>Efficient water management and soil conservation practices help mitigate erosion, optimize water use, and improve drought resilience.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Efficient Irrigation Practices" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Install drip irrigation or soaker hoses to reduce evaporation and deliver water directly to the root zone.</li>
                                    <li>Schedule irrigation based on soil moisture levels rather than fixed intervals.</li>
                                    <li>Use organic mulch to retain moisture and prevent water loss.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Rainwater Harvesting" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Collect and store rainwater in cisterns or ponds for irrigation.</li>
                                    <li>Use swales and contour ditches to capture and distribute rainwater.</li>
                                    <li>Implement bioswales or filter strips to manage excess runoff.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Soil Erosion Prevention" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Plant cover crops (e.g., rye, mustard, clover) to protect soil from wind and water erosion.</li>
                                    <li>Use contour farming and terracing on sloped land to reduce runoff and soil loss.</li>
                                    <li>Avoid overgrazing and compacting soil with heavy machinery.</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </>         
            ),
        },
        {
            key: '3',
            label: 'Crop & Farm Management',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>A well-planned cropping system enhances soil fertility, reduces disease risks, and optimizes resource use.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Crop Rotation & Diversification" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Rotate crops seasonally to prevent pest and disease buildup.</li>
                                    <li>Implement a 3–4-year crop rotation system that includes nitrogen-fixing crops.</li>
                                    <li>Use diverse plant species to improve soil structure and nutrient availability.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Intercropping Strategies" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Plant complementary crops together to maximize land use and suppress weeds.</li>
                                    <li>Use trap crops to attract pests away from main crops.</li>
                                    <li>Grow flowering plants alongside cash crops to encourage pollinators and beneficial insects.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Sustainable Harvesting Practices" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Harvest crops at their optimal maturity to reduce losses and improve post-harvest quality.</li>
                                    <li>Use gentle harvesting techniques to avoid damage to fruits and vegetables.</li>
                                    <li>Store produce properly using natural preservation methods such as drying or fermentation.</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </> 
            ),
        },
        {
            key: '4',
            label: 'Pest, Disease & Weed Control',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>Managing pests and diseases organically minimizes chemical inputs while protecting crop health.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Integrated Pest Management (IPM)" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Combine biological, cultural, mechanical, and organic control methods.</li>
                                    <li>Use pheromone traps and sticky traps to monitor and manage insect populations.</li>
                                    <li>Rotate crops and use resistant varieties to naturally suppress pests.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Encouraging Beneficial Insects" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Support natural predators such as ladybugs, lacewings, and parasitoid wasps.</li>
                                    <li>Plant pollinator-friendly species (e.g., wildflowers, buckwheat) to attract beneficial insects.</li>
                                    <li>Provide insect shelters such as beetle banks or flowering hedgerows.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Organic Weed Suppression" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Apply organic mulch (straw, leaves, grass clippings) to block weed germination.</li>
                                    <li>Use flame weeding or solarization as chemical-free weed control methods.</li>
                                    <li>Manually remove weeds using hoes or hand-pulling to prevent seed spread.</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </> 
            ),
        },
        {
            key: '5',
            label: 'Energy & Resource Efficiency',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>Reducing energy and input costs helps improve farm sustainability while lowering environmental impact.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Reducing Fuel Consumption" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Opt for manual or low-energy tools instead of fossil fuel-powered machinery.</li>
                                    <li>Implement regenerative grazing to minimize tractor use.</li>
                                    <li>Use electric or biofuel-powered equipment where feasible.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Utilizing Renewable Energy" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Install solar panels or wind turbines to generate on-farm electricity.</li>
                                    <li>Use passive greenhouse heating techniques to reduce energy consumption.</li>
                                    <li>Implement biogas systems for converting organic waste into usable energy.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Recycling & Waste Reduction" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Compost plant residues, manure, and food scraps to create nutrient-rich soil amendments.</li>
                                    <li>Repurpose materials such as wood, old equipment, or containers for farm structures.</li>
                                    <li>Utilize biodegradable packaging and reduce plastic waste where possible.</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </> 
            ),
        },
        {
            key: '6',
            label: 'Biodiversity & Ecosystem Support',
            children: (
                <>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={24}>
                            <Card>
                                <h3 style={{ textAlign: 'center', padding: '0 20px' }}>Promoting biodiversity ensures ecological balance and improves farm resilience.</h3>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[12, 24]} style={{ marginTop: 15 }}>
                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Habitat Conservation" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Create hedgerows, buffer strips, and field margins to support wildlife.</li>
                                    <li>Restore native vegetation to attract beneficial organisms.</li>
                                    <li>Establish agroforestry systems with tree crops and understory plants.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Pollinator Protection" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Maintain flowering plant strips near crop fields.</li>
                                    <li>Reduce pesticide use to avoid harming bees and other pollinators.</li>
                                    <li>Provide nesting habitats for wild bees and butterflies.</li>
                                </ul>                  
                            </Card>
                        </Col>

                        <Col span={8} xs={24} md={12} lg={8} xxl={6}>
                            <Card 
                                title="Sustainable Land Use" 
                                variant="borderless" 
                                hoverable={true} 
                                styles={{
                                    header: { fontSize: '16px', color: '#333', backgroundColor: '#d4dfd4' },
                                    body: { color: '#555', fontSize: '14px', paddingLeft:0 }
                                }}
                            >
                                <ul>
                                    <li>Balance production areas with conservation zones.</li>
                                    <li>Implement rotational grazing to prevent overgrazing and improve soil health.</li>
                                    <li>Preserve wetlands, waterways, and natural habitats around the farm.</li>
                                </ul>                  
                            </Card>
                        </Col>
                    </Row>
                </> 
            ),
        },
    ];

    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>Recommendations</h1>         
            </div>   

            <div>
                <Tabs tabPosition={"top"} type="card" size='large' items={items} className="custom-tabs data_visual_tabs"  style={{ flex: 1 }} />
            </div>
        </>
    );
}

export default Recommendations;